import React from "react";
import PropTypes from "prop-types";

import SvgIcon from "../Icon/SvgIcon.jsx";

/**
 * Переопределить визуал элемента, отвечающего за сброс выбранного значения из выпадающего списка
 *
 * @param innerProps
 * @return {JSX.Element}
 */
export const ClearIndicator = ({ innerProps }) => {
  const { ref, ...restInnerProps } = innerProps;
  return (
    <div {...restInnerProps} ref={ref}>
      <SvgIcon name="close" size="lg" color="#AAABAD" />
    </div>
  );
};

ClearIndicator.propTypes = {
  innerProps: PropTypes.object.isRequired,
};
